export default {
  参观商: '参观商',
  主办商: '主办商',
  参展商: '企业',
  设计师: '设计师',
  '设计师（企业）': '设计师（企业）',
  '设计师（个人）': '设计师（个人）',
  工程商: '工程商',
  展厅工程商: '展厅工程商',
  主账号: '主账号',
  子账号: '子账号',
  岗位名称: '岗位名称',
  手机: '手机',
  手机号: '手机号',
  手机号码: '手机号码',
  固话: '固话',
  电话: '电话',
  邮箱: '邮箱',
  地址: '地址',
  姓名: '姓名',
  公司: '公司',
  公司地址: '公司地址',
  普通会员: '普通会员',
  普通用户: '普通用户',
  VIP会员: 'VIP会员',
  开通VIP会员: '开通VIP会员',
}
